import { useEffect, useState } from 'react';

import { useGlobalError } from 'hooks/useGlobalError';
import { paymentService } from 'services/payment/paymentService';
import { OrganizationDto } from 'services/payment/paymentService.dto';

export const useSearchOrganizations = (searchPhrase: string) => {
  const [organizations, setOrganizations] = useState<OrganizationDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { unknownError } = useGlobalError();

  const adjustedSearchPhrase = adjustSearchPhrase(searchPhrase);

  useEffect(() => {
    if (adjustedSearchPhrase) {
      const keywords: string[] = adjustedSearchPhrase.split(' ');
      setIsLoading(true);
      paymentService
        .fetchOrganizationsByKeywords(keywords)
        .then(result => setOrganizations(result.data))
        .catch(() => {
          setOrganizations([]);
          unknownError();
        })
        .finally(() => setIsLoading(false));
    }
  }, [adjustedSearchPhrase]);

  return { organizations, isLoading };
};

const adjustSearchPhrase = (searchPhrase: string) => {
  const trimmedSearchPhrase = searchPhrase.trim();
  return !!trimmedSearchPhrase ? trimmedSearchPhrase : undefined;
};
